<template>
	<v-container fluid class="mr-10">
        <v-row>
            <v-col class="d-flex" cols="12" sm="6">
                <p class="text-h3">{{$t('message.store')}}</p>
            </v-col>
		</v-row>
        <v-row>  
            <v-col class="d-flex">
                <v-expansion-panels flat accordion v-model="panel">
                    <v-expansion-panel>
                        <v-expansion-panel-header hide-actions>
                            <v-btn tile outlined max-width="120">
                                <v-icon left>mdi-chart-gantt</v-icon>{{$t('message.filters')}}
                            </v-btn>
                            <v-btn link tile outlined max-width="120" @click.native.stop @click="clear" v-if="showClear">
                                Limpar
                            </v-btn>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-text-field
                                v-model="searchName"
                                label="Nome"
                                placeholder="Digite um nome de Produto"
                                outlined
                                clearable
                            ></v-text-field>
                            <v-select
                                :items="contexts"
                                item-text="name"
                                :label="$t('message.contexts')"
                                outlined
                                multiple
                                :hint="$t('message.contexts_select_hint')"
                                :menu-props="{offsetY: true}"
                                persistent-hint
                                v-model="selectedContexts"
                                return-object
                            ></v-select>
                            <v-select
                                :items="avaiableSections"
                                item-text="name"
                                :label="$t('message.sections')"
                                outlined
                                multiple
                                :hint="$t('message.sections_select_hint')"
                                :menu-props="{offsetY: true}"
                                persistent-hint
                                v-model="selectedSections"
                                return-object
                            ></v-select>
                        </v-expansion-panel-content>
                    </v-expansion-panel>        	
                </v-expansion-panels>			
			</v-col>
		</v-row>
        <v-divider></v-divider>
        <v-container>
            <p class="subtitle-1">{{filteredProductsLength}} {{$t("message.products_found")}}</p>
            <v-row align="start">            
                <Product v-for="product in filteredProducts" v-bind:item="product" v-bind:key="product.id" :product="product"></Product>
                <div class="section" v-if="this.filteredProductsLength === 0">
                    <p>{{ $t("message.no_products_found") }}</p>
                </div>
            </v-row>
        </v-container>
	</v-container>
</template>

<script>
import Product from "../components/Product";
import Utils from '../utils/utils';
import { GET_PRODUCTS } from '../store/actions/store';
export default {
  	components: { Product },
	data() {
		return {            
            products:[],
            contexts:[],
            sections:[],
            selectedContexts: [],
            selectedSections: [],
            searchName: "",
            panel: 1
		};
	},
    methods: { 
        clear(){
            this.searchName = "";
            this.selectedContexts = [];
            this.selectedSections = [];
        }
    },
    beforeMount(){
        this.searchName = this.$store.getters.productsFilters.text;
        this.selectedContexts = this.$store.getters.productsFilters.contexts;
        this.selectedSections = this.$store.getters.productsFilters.sections;
        if(this.searchName != '' || this.selectedContexts.length > 0 || this.selectedSections.length > 0){
            this.panel = 0;
        }
    },
    mounted(){
        var token = this.$store.state.auth.token;
        this.$store.dispatch(GET_PRODUCTS, {token})
            .then(products=>{
                this.products = products;
                this.contexts = [];
                this.sections = [];
                products.forEach((product)=>{
                    product.cards.forEach((card)=>{
                        if(!Utils.containsSection(this.sections, card.section)){
                            this.sections.push(card.section);
                        }
                        if(!Utils.containsSection(this.contexts, card.section.context)){
                            this.contexts.push(card.section.context);
                        }
                    });
                });
            });
    },
	computed: {
        showClear(){
            if(this.searchName != '' || this.selectedContexts.length > 0 || this.selectedSections.length > 0){
                return true;
            }
            return false;
        },
        avaiableSections(){
            if(this.selectedContexts.length==0){
                return this.sections;
            }else{
                var filtered = [];
                this.sections.forEach(section=>{
                    this.selectedContexts.forEach(context=>{
                        if(section.context.id == context.id){
                            filtered.push(section);
                        }
                    })                        
                })
                return filtered;
            }
        },
		filteredProductsLength() {            
			return this.filteredProducts.length;
        },
        filteredProducts(){
            var sectionFiltered = [];
            if(this.selectedSections.length == 0 && this.selectedContexts.length==0){
                sectionFiltered = this.products;
            }else{
                if(this.selectedSections.length == 0){
                    this.products.forEach(product=>{
                        this.selectedContexts.forEach(context=>{
                            if(product.cards[0].section.context.id == context.id){
                                if(!Utils.contains(sectionFiltered,product)){
                                    sectionFiltered.push(product);
                                }
                            }
                        })
                    });
                }else{
                    this.products.forEach(product=>{
                        this.selectedSections.forEach(section=>{
                            if(product.cards[0].section.id == section.id){
                                if(!Utils.contains(sectionFiltered,product)){
                                    sectionFiltered.push(product);
                                }
                            }
                        });       
                    });             
                }
            }
            var filtered = [];
            if(this.searchName != ""){
                filtered = sectionFiltered.filter((product)=>{
                    return this.searchName.toLowerCase().split(' ').every(v => product.title.toLowerCase().includes(v));
                });
            }else{
                filtered = sectionFiltered
            }
            this.$store.dispatch("UPDATE_PRODUCTS_TEXT", this.searchName);
            this.$store.dispatch("UPDATE_PRODUCTS_SELECTS", {sections: this.selectedSections, contexts:this.selectedContexts});
            return filtered;
        }
	},
    
};
</script>